import Api from './Api';

const END_POINT = 'recipes';

export default{
    async get_all (filters) {
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}`, request);
    },
    async store(data) {
        return await Api.post(`${END_POINT}`, data);
    },
}